<div class="iframe-container">
    <iframe src="https://info.sportsengineplay.com/promo/myse-sep/?iframe"></iframe>
</div>
